<template>
    <v-layout class="component-wrap">
        <Users />
    </v-layout>
</template>

<script>
import Users from '@/components/view_blocks/Users/Users_wrap';

export default {
  components: {
    Users,
  },
};
</script>
